// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container__DgzGU","container_pagination":"Pagination_container_pagination__-GUHH","pagination_page":"Pagination_pagination_page__1TreJ"};